import { lazy, Suspense } from "react";
import { Header } from "@/components/layout/Header";
import { HeroSection } from "@/components/home/HeroSection";

const FeaturedCourses = lazy(() =>
  import("@/components/home/FeaturedCourses").then((m) => ({ default: m.FeaturedCourses })),
);
const WhyDQS = lazy(() =>
  import("@/components/home/WhyDQS").then((m) => ({ default: m.WhyDQS })),
);
const CategoriesSection = lazy(() =>
  import("@/components/home/CategoriesSection").then((m) => ({ default: m.CategoriesSection })),
);
const CorporateSection = lazy(() =>
  import("@/components/home/CorporateSection").then((m) => ({ default: m.CorporateSection })),
);
const CTASection = lazy(() =>
  import("@/components/home/CTASection").then((m) => ({ default: m.CTASection })),
);
const Footer = lazy(() =>
  import("@/components/layout/Footer").then((m) => ({ default: m.Footer })),
);

const SectionSkeleton = () => <div className="min-h-[200px]" aria-hidden="true" />;

const Index = () => {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1">
        <HeroSection />
        <Suspense fallback={<SectionSkeleton />}>
          <FeaturedCourses />
        </Suspense>
        <Suspense fallback={<SectionSkeleton />}>
          <WhyDQS />
        </Suspense>
        <Suspense fallback={<SectionSkeleton />}>
          <CategoriesSection />
        </Suspense>
        <Suspense fallback={<SectionSkeleton />}>
          <CorporateSection />
        </Suspense>
        <Suspense fallback={<SectionSkeleton />}>
          <CTASection />
        </Suspense>
      </main>
      <Suspense fallback={<SectionSkeleton />}>
        <Footer />
      </Suspense>
    </div>
  );
};

export default Index;
